(ns pfo.auth.core (:require
                     [pfo.state :as state]
                     [pfo.common.component :refer [empty-page]]
                     [goog.crypt.base64 :as gbase64]
                     [pfo.util :as util]
                     [pfo.state :as state]
                     [pfo.auth.model :as model]
                     [pfo.auth.component :as component]
                     [promesa.core :as p]
                     [pfo.api :as api :refer [process-error]]))

(def $ js/$)

;; Our own IdP's SSO endpoint. Registered on the root router, not under
;; API_BASE_URL, so this path is literal. Never take it from the request blob —
;; that blob rides the URL fragment and the form carries the session token.
(def saml-sso-path "/auth/saml/sso")

(defn saml-login [{:keys [id query-params]}]
  (let [saml-request (js->clj (.parse js/JSON (gbase64/decodeString (:req query-params))) :keywordize-keys true)]
    (reset! state/use-local-auth-state true)
    (reset! state/auth-service-provider (:ServiceProviderName saml-request))
    ;; Below: commented out for #187627196
    ;; Was added here with subscriber templates, which included some smarteru stuff
    ;; Not sure why it was hardcoded.
    ;; Leaving here for when SmarterU is revisited (e.g. in 2056)
    ;; (reset! state/auth-url "/smarteru/authenticate/")
    (util/set-initial-page empty-page)
    (api/set-auth-info :success-cb (fn []
                                     (-> ($ "body") (.append
                                                      (-> ($ "<form></form>")
                                                          (.attr "method" "post")
                                                          (.attr "action" saml-sso-path)
                                                          (.attr "id" "SAMLResponseForm")
                                                          (.append (-> ($ "<input></input>")
                                                                       (.attr "type" "hidden")
                                                                       (.attr "name" "SAMLRequest")
                                                                       (.val (:SAMLRequest saml-request))))
                                                          (.append (-> ($ "<input></input>")
                                                                       (.attr "type" "hidden")
                                                                       (.attr "name" "RelayState")
                                                                       (.attr "value" (:RelayState saml-request))))
                                                          (.append (-> ($ "<input></input>")
                                                                       (.attr "type" "hidden")
                                                                       (.attr "name" "ServiceProviderID")
                                                                       (.attr "value" (:ServiceProviderID saml-request))))
                                                          (.append (-> ($ "<input></input>")
                                                                       (.attr "type" "submit")
                                                                       (.attr "id" "SAMLSubmitButton")
                                                                       (.attr "value" "Continue")
                                                                       (.css "visibility" "hidden")))
                                                          (.append (-> ($ "<input></input>")
                                                                       (.attr "type" "hidden")
                                                                       (.attr "name" "token")
                                                                       (.attr "value" (api/get-auth-token))
                                                                       (.css "visibility" "hidden")))
                                                          )))
                                     (-> ($ "#SAMLResponseForm") .submit)))
    (api/set-auth-info :auth-state :logged-out)))

(defn support [{:keys [id query-params]}]
  (util/set-initial-page empty-page)
  (->> (model/support-sso)
       (p/map (fn [response]
                (-> js/document .open)
                (-> js/document (.write response))
                (-> js/document .close)))))

(defn error-page [{:keys [query-params]}]
  (->>
    (api/ajaxp "/weblink/message/" {:params {:key (:key  query-params)}})
    (p/map (fn [response]
             (util/set-page-with-meta {:login-layout true} #'component/error-page (:message response))))
    (process-error)))
